import { api } from './api';

/**
 * Pra-panas worker HD untuk kamera yang sedang **ditunjuk** operator (§D3.6).
 *
 * Membuka satu kamera layar penuh menuntut worker `main` dinyalakan, dan itu
 * 3,3 detik yang dibayar tepat saat orangnya menunggu. Yang diubah di sini
 * bukan lamanya, melainkan **kapan** dibayarnya: penunjuk yang berhenti di
 * sebuah tile hampir selalu mendahului klik pada tile itu, dan jeda antara
 * "melihat sesuatu yang aneh" dan "menekan tombol" biasanya lebih panjang
 * daripada 3,3 detik.
 *
 * Satu kamera saja pada satu waktu. Bukan penghematan mikro: worker HD adalah
 * transcode 1920px, dan penunjuk yang menyapu grid 6×5 akan menyalakan tiga
 * puluh di antaranya kalau tidak dijaga.
 *
 * Dua penjaga di sini, sisanya di server (§D3.6):
 *
 * - **Jeda 350 ms** sebelum apa pun dikirim. Penunjuk yang cuma lewat di atas
 *   tile menuju tile lain tidak menyalakan apa-apa; yang menyalakan adalah
 *   penunjuk yang berhenti.
 * - **Pembaruan berkala** selama penunjuknya masih di sana, karena pegangan di
 *   server memang sengaja berumur pendek.
 */

/** Penunjuk harus diam selama ini dulu sebelum dianggap "menunjuk". */
const JEDA_MS = 350;

/** Pegangan di server 30 detik; diperbarui lebih awal supaya tidak pernah bolong. */
const PERBARUI_MS = 20_000;

let target: string | null = null;
let timerJeda: number | undefined;
let timerPerbarui: number | undefined;

function kirim(cameraId: string): void {
  // Kegagalan sengaja ditelan. Pra-panas adalah tebakan: kalau ia tidak sampai,
  // yang terjadi persis keadaan sebelum fitur ini ada — bukan kesalahan yang
  // perlu diberitahukan kepada siapa pun.
  void api(`/stream/${cameraId}/main/prewarm`, { method: 'POST' }).catch(() => undefined);
}

/**
 * Nyatakan kamera mana yang sedang ditunjuk. `null` berarti tidak ada.
 *
 * Aman dipanggil sesering apa pun — pemanggilan berulang untuk kamera yang sama
 * tidak menghasilkan permintaan tambahan.
 */
export function tunjukKamera(cameraId: string | null): void {
  if (cameraId === target) return;
  target = cameraId;

  window.clearTimeout(timerJeda);
  window.clearInterval(timerPerbarui);

  if (cameraId === null) return;

  timerJeda = window.setTimeout(() => {
    kirim(cameraId);
    timerPerbarui = window.setInterval(() => {
      // Penunjuk sudah pindah di antara dua detak — hentikan, jangan menahan
      // worker HD untuk kamera yang tidak dilihat siapa pun lagi.
      if (target !== cameraId) {
        window.clearInterval(timerPerbarui);
        return;
      }
      kirim(cameraId);
    }, PERBARUI_MS);
  }, JEDA_MS);
}
